import React from 'react'
import { Menu as MenuAnt, Icon } from 'antd'
import { MenuProps } from 'antd/lib/menu'
import { SubMenuProps } from 'antd/lib/menu/SubMenu'
import { MenuItemProps } from 'antd/lib/menu/MenuItem'

import { useT } from 'src/core/hooks/use-translation'

function Menu({
  children,
  mode = 'inline',
  theme = 'dark',
  ...props
}: MenuProps & { children?: any }) {
  return (
    <MenuAnt {...props} mode={mode} theme={theme}>
      {children}
    </MenuAnt>
  )
}

function MenuItem({
  children,
  title,
  icon,
  ariaLabel,
  ...props
}: MenuItemProps & {
  ariaLabel?: string
  icon?: any
}) {
  const { t } = useT()
  const image = icon ? (
    typeof icon === 'string' ? (
      <Icon type={icon} />
    ) : (
      icon
    )
  ) : null
  return (
    <MenuAnt.Item {...props}>
      {image}
      <span aria-label={ariaLabel}>{t(title)}</span>
      {children}
    </MenuAnt.Item>
  )
}

function MenuSubMenu({
  children,
  icon,
  title,
  ...props
}: SubMenuProps & { children?: any; icon?: string }) {
  const { t } = useT()
  return (
    <MenuAnt.SubMenu
      {...props}
      title={
        <span>
          {icon && <Icon type={icon} />}
          <span>{t(title)}</span>
        </span>
      }
    >
      {children}
    </MenuAnt.SubMenu>
  )
}

export default Menu
export { MenuItem, MenuSubMenu }
